import React from 'react';
export default function NoResults() {
    return React.createElement("div", { className: 'cio-no-results-message' }, "No Results Found");
}
